import {useLoader} from "@react-three/fiber";
import {GLTFLoader} from "three/examples/jsm/loaders/GLTFLoader";
import React, {useRef} from "react";
import MaterialInitialiser from "../materials/MaterialInitialiser";
import ModelModuleManager from "../custom-modules/module/ModelModuleManager";
import Initialiser from "../initialiser/Initialiser";
import {MemModuleModel} from "../custom-modules/module/ModuleModel";
import ModelCollider from "../custom-modules/module/ModelCollider";
import ModulesMenuController from "../custom-modules/module/ui/ModulesMenuController";
import FrontWallGenerator from "../custom-modules/panels/FrontWallGenerator";
import BackWallGenerator from "../custom-modules/panels/BackWallGenerator";

import PanelsBuilderGUI from "../custom-modules/panels/ui/PanelsBuilderGUI";

// import {BufferGeometryUtils} from 'three/examples/jsm/utils/BufferGeometryUtils';
// new BufferGeometryUtils().mergeBufferGeometries(geometries)
// const geometries = BufferGeometryUtils.mergeBufferGeometries(modelStaticList, true);
// const mesh = THREE.Mesh(geometries, materialStaticList);

const InitModels = ({protoObjects, cloneObjects, staticObjects, geometriesData, camera, object}) => {
  
  const staticModulesRef = useRef([]);
  
  return (

    <group>
  
      {staticObjects.map((geom, index) => {
        return (
          <MemModuleModel key={index} geom={geom} material={geom.material} att={{group: geom.name.includes('Static') ? 'static' : 'toggle', set: geom.name.split('_').pop()}}/>
        )
      })}
      
      {cloneObjects.map((item, index) => {
        
        const proto = protoObjects.find(obj => obj.name === item.name);
        
        // position group
        return (
          
          <group dir={item.dir} key={index} index={index} refNo={item.ref} name={item.meshSet.name}
                 position={item.meshSet.position} rotation={item.meshSet.rotation}
                 ref={(el) => (staticModulesRef.current[index] = el)}>
            
            {proto.meshSet['children'].map((geom, index) => {
  
              // console.log('geom', geom)
              
              const type = 'static';
              
              return (
                <MemModuleModel key={index} geom={geom} material={geom.material} att={{group: geom.name.includes('Static') ? 'static' : 'toggle', set: geom.name.split('_').pop()}}/>
              )
            })}
            
          </group>
        );
        
      })}
  
      <BackWallGenerator camera={camera} geometriesData={geometriesData}
                               staticModulesRef={staticModulesRef} datumPoint={'clone_post1_001'}/>
                               
      <FrontWallGenerator camera={camera} geometriesData={geometriesData}
                                staticModulesRef={staticModulesRef} datumPoint={'clone_post1_002'}/>
      
    </group>
    
  )
};

export default InitModels;
